/* eslint-disable  no-underscore-dangle */

import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { dateFilterPlugin as newDateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import HotelViewBase from '../assignment-utils/hotel-view-base';
import HotelOutGroupOptions from './grid-options';
import { initializeFilterAgent } from '../assignment-utils/filter-agent';
import { getFilterConfig } from '../assignment-utils/filter-config';

const appConfig = globalContext.require('component/config/index');
const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');

/**
 * Class representing a navigation tabs for HotelOutGroupView
 * @extends View
 */
export default class HotelOutGroupView extends HotelViewBase {
  initialize({
    perfMarker,
    isUINext = false,
    preferenceStoreFactory,
    preferenceService,
    sessionStore,
  } = {}) {
    super.initialize();
    this.preferenceStoreFactory = preferenceStoreFactory;
    this.preferenceService = preferenceService;
    this.sessionStore = sessionStore;
    this.perfMarker = perfMarker;
    this.isUINext = isUINext;
    this.searchPropertyName = 'HotelName';
  }

  renderTrunk() {
    super.renderTrunk();

    if (this.gridFactory) {
      const gridOptions = new HotelOutGroupOptions({
        onSearchInvoked: searchTerm => this.onSearchInvoked(searchTerm),
        excludeGroupId: this.getState().excludeGroupId,
        perfMarker: this.perfMarker,
        appConfig,
        isUINext: this.isUINext,
      });
      this.filterToolbar = gridOptions.filterToolbar;

      this.grid = this.gridFactory
        .use(newDateFilterPlugin)
        .use(perfMarkerPlugin)
        .create(gridOptions);

      super.gridCreated();

      this.grid.gridView.on('didSelect', (selected) => {
        this.trigger('selectionChanged', selected);
      });

      // Cross page selection should be reset after grid reload
      this.grid.gridView.on('didReload', () => {
        this.grid.gridView.deselectAll();
      });

      initializeFilterAgent({
        filterConfig: getFilterConfig({
          schema: gridOptions.schema,
          i18n,
          featureName: 'HotelOutGroup',
          preferenceStoreFactory: this.preferenceStoreFactory,
          preferenceService: this.preferenceService && this.preferenceService.default,
          sessionStore: this.sessionStore,
        }),
        gridView: this.grid.gridView,
        tabView: this,
        toolbar: this.filterToolbar,
      });

      $('.hotel-out-group__container .grid-container').append(this.grid.gridView.render().$el);
    }
  }
}
